/**
 * Routes publiques « hors application » : un visiteur non authentifié peut y
 * rester sans être redirigé vers /auth (connexion, inscription, callbacks
 * OAuth, complétion de profil).
 *
 * Une seule liste pour deux lecteurs qui doivent rester d'accord :
 * - `AuthProvider` (redirection + gate de rendu) ;
 * - `useCrisp` (pas de canal support tant que la personne n'est pas entrée
 *   dans l'application, même si une session existe déjà — cas de l'étape
 *   paiement de `/inscription`).
 *
 * `/invite/*` n'y figure pas : aucune route n'existe pour ce chemin dans
 * App.tsx, l'invitation passe par l'e-mail Supabase → /complete-profile.
 */
export function isPublicAuthPath(pathname: string): boolean {
  return (
    pathname === "/auth" ||
    pathname === "/inscription" ||
    pathname.startsWith("/inscription/") ||
    pathname.startsWith("/auth/") ||
    pathname === "/complete-profile"
  );
}
